import React, { useContext, useEffect, useState } from 'react';

import { ApiRoutes, FetchContext, HttpMethods } from '../../contexts';


import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { SearchType, useAggregatedState } from '../../../helpers';

// import Cookies from 'universal-cookie';

export const ResearchContext = React.createContext(null);

const { Provider } = ResearchContext;

const sortUffici = (list) => {
    list.sort((a, b) => {
        if (a.tipoUfficio?.ordine && b.tipoUfficio?.ordine)
            return a.tipoUfficio.ordine - b.tipoUfficio.ordine;

        a.tipoUfficio?.nome.localeCompare(b.tipoUfficio?.nome);

        return 0;
    })
}

export const ResearchProvider = (props) => {

    const location = useLocation();

    const [comuneFilter, setComuneFilter] = useState("");
    const [regioneFilter, setRegioneFilter] = useState("");
    const [provinciaFilter, setProvinciaFilter] = useState("");
    const [distrettoFilter, setDistrettoFilter] = useState("");
    const [circondarioFilter, setCircondarioFilter] = useState("");
    const [tipoUfficioFilter, setTipoUfficioFilter] = useState("");
    const [testoFilter, setTestoFilter] = useState("");
    const [ufficiFilter, setUfficiFilter] = useState("");
    const [isLoadingFilterFromCookies, setIsLoadingFilterFromCookies] = useState(false);
    const [tableResultTitle, setTableResultTitle] = useState("");
    const [tableResultSubtitle, setTableResultSubtitle] = useState("");
    const [tableResultSubtitle2, setTableResultSubtitle2] = useState("");
    const [advancedSearchActive, setAdvancedSearchActive] = useState(false);
    const [activeSearchType, setActiveSearchType] = useState("");

    const { fetchOk } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
        comuni: [],
        comuniOptions: [],

        tuttiTipiUffici: [],
        tuttiTipiUfficioptions: [],

        tipiUffici: [],
        tipiUfficiOptions: [],

        tipiUfficiRicerca: [],
        tipiUfficiRicercaOptions: [],

        regioni: [],
        regioniOptions: [],

        province: [],
        provinceOptions: [],

        distretti: [],
        distrettiOptions: [],

        circondari: [],
        circondariOptions: [],

        uffici: [],
        altriUffici: [],

        storiciUfficio: null,
        storiciCompetenza: null,

        storiciUffici: [],
        storiciCompetenze: [],

        storiciUfficioId: null,
        storiciCompetenzaId: null,
    });

    const handleSearchSubmit = () => {
        // const cookies = new Cookies();

        // cookies.set('comuneFilter', comuneFilter);
        // cookies.set('regioneFilter', regioneFilter);
        // cookies.set('provinciaFilter', provinciaFilter);
        // cookies.set('distrettoFilter', distrettoFilter);
        // cookies.set('circondarioFilter', circondarioFilter);
        // cookies.set('tipoUfficioFilter', tipoUfficioFilter);
        // cookies.set('testoFilter', testoFilter);
        buildResultTableTitle();

        if (comuneFilter) {
            var comune = state.comuniOptions.filter(x => x.comuneId == comuneFilter)[0].label;
            getComuneUfficiAsync(comuneFilter);
            getComuneAltriUfficiAsync(comuneFilter);
        }
        if (regioneFilter || provinciaFilter) {
            getUfficiTerritorioAsync(regioneFilter, provinciaFilter);
        }
        if (distrettoFilter || circondarioFilter) {
            getUfficiDistrettoAsync(distrettoFilter, circondarioFilter);
        }
        if (tipoUfficioFilter) {
            getUfficiTipoUfficioAsync(tipoUfficioFilter);
        }
        if (testoFilter) {
            getUfficiLiberaAsync(testoFilter);
        }
    }

    const handleResetSearch = () => {
        setComuneFilter("");
        setRegioneFilter("");
        setProvinciaFilter("");
        setDistrettoFilter("");
        setCircondarioFilter("");
        setTipoUfficioFilter("");
        setTestoFilter("");
        setUfficiFilter("");
        clearResult();
    }

    const clearResult = () => {
        setTableResultTitle("Effettua una ricerca per visualizzare i risultati");
        setTableResultSubtitle("");
        setState({
            uffici: [],
            altriUffici: [],
            storiciUffici: [],
            storiciCompetenze: [],
            ufficiXML: null,
            altriUfficiXML: null,
        });
    }

    const handleWidgetSearchSubmit = async (comuneFilterWidget, regioneFilterWidget, provinciaFilterWidget, distrettoFilterWidget, circondarioFilterWidget, tipoUfficioFilterWidget, testoFilterWidget, ufficiFilterWidget) => {
        if (comuneFilterWidget) {
            await getComuneUfficiAsync(comuneFilterWidget);
            await getComuneAltriUfficiAsync(comuneFilterWidget);
        }
        if (regioneFilterWidget || provinciaFilterWidget) {
            await getUfficiTerritorioAsync(regioneFilterWidget, provinciaFilterWidget);
        }
        if (distrettoFilterWidget || circondarioFilterWidget) {
            await getUfficiDistrettoAsync(distrettoFilterWidget, circondarioFilterWidget);
        }
        if (tipoUfficioFilterWidget) {
            await getUfficiTipoUfficioAsync(tipoUfficioFilterWidget);
        }
        if (testoFilterWidget) {
            await getUfficiLiberaAsync(testoFilterWidget);
        }
        if (ufficiFilterWidget) {
            await getUfficiAsync(ufficiFilterWidget);
        }
        buildResultTableTitle(comuneFilterWidget, regioneFilterWidget, provinciaFilterWidget, distrettoFilterWidget, circondarioFilterWidget, tipoUfficioFilterWidget, testoFilterWidget, ufficiFilterWidget);

    }

    const buildResultTableTitle = (comuneFilterWidget, regioneFilterWidget, provinciaFilterWidget, distrettoFilterWidget, circondarioFilterWidget, tipoUfficioFilterWidget, testoFilterWidget, ufficiFilterWidget) => {

        var comuneValue = comuneFilter ? comuneFilter : comuneFilterWidget;
        var regioneValue = regioneFilter ? regioneFilter : regioneFilterWidget;
        var provinciaValue = provinciaFilter ? provinciaFilter : provinciaFilterWidget;
        var distrettoValue = distrettoFilter ? distrettoFilter : distrettoFilterWidget;
        var circondarioValue = circondarioFilter ? circondarioFilter : circondarioFilterWidget;
        var tipoUfficioValue = tipoUfficioFilter ? tipoUfficioFilter : tipoUfficioFilterWidget;
        var testoValue = testoFilter ? testoFilter : testoFilterWidget;
        var ufficiValue = ufficiFilterWidget ? ufficiFilterWidget : ufficiFilter;
        if (comuneValue && state.comuniOptions && state.comuniOptions.length > 0) {
            var comune = state.comuniOptions.filter(x => x.comuneId == comuneValue)[0].label;
            setTableResultTitle(`Risultati della ricerca per ${comune}`);
            setTableResultSubtitle(`UFFICI GIUDIZIARI COMPETENTI`);
            setTableResultSubtitle2(`ISTITUTI PENITENZIARI, STRUTTURE MINORILI E ALTRI UFFICI`);
        }
        if ((regioneValue || provinciaValue) && state.regioniOptions && state.regioniOptions.length > 0) {
            var regione = state.regioniOptions.filter(x => x.regioneId == regioneValue)[0]?.label;
            var provincia = null;
            if (provinciaFilter && state.provinceOptions && state.provinceOptions.length > 0) {
                provincia = state.provinceOptions.filter(x => x.provinciaId == provinciaValue)[0]?.label;
            }

            if (provincia) {
                setTableResultTitle(`Risultati della ricerca per ${provincia} ${regione ? `(${regione})` : ``}`);
                setTableResultSubtitle(`UFFICI NELLA PROVINCIA`);
                setTableResultSubtitle2("");
            }
            else {
                setTableResultTitle(`Risultati della ricerca per ${regione}`);
                setTableResultSubtitle(`UFFICI NELLA REGIONE`);
                setTableResultSubtitle2("");
            }

        }
        if ((distrettoValue || circondarioValue) && state.distrettiOptions && state.distrettiOptions.length > 0) {

            var distretto = state.distrettiOptions.filter(x => x.ufficioId == distrettoValue)[0]?.label;
            var circondario = null;
            if (circondarioFilter && state.circondariOptions && state.circondariOptions.length > 0) {
                circondario = state.circondariOptions.filter(x => x.ufficioId == circondarioValue)[0]?.label;
            }

            if (circondario) {
                setTableResultTitle(`Risultati della ricerca per ${circondario} ${distretto ? `(${distretto})` : ``}`)
                setTableResultSubtitle(`UFFICI COMPETENTI NEL CIRCONDARIO`);
                setTableResultSubtitle2("");
            }
            else {
                setTableResultTitle(`Risultati della ricerca per ${distretto}`);
                setTableResultSubtitle(`UFFICI COMPETENTI NEL DISTRETTO`);
                setTableResultSubtitle2("");
            }
        }
        if (tipoUfficioValue && state.tipiUfficiOptions && state.tipiUfficiOptions.length > 0) {
            var tipoUfficio = state.tipiUfficiOptions.filter(x => x.tipoUfficioId == tipoUfficioValue)[0]?.label;

            if (tipoUfficio) {
                setTableResultTitle(`Risultati della ricerca per ${tipoUfficio}`)
                setTableResultSubtitle(`UFFICI`);
                setTableResultSubtitle2("");
            }
        }
        if (testoValue) {
            setTableResultTitle(`Risultati della ricerca per testo: ${testoValue}`)
            setTableResultSubtitle(`UFFICI`);
            setTableResultSubtitle2("");
        }
        if (ufficiValue) {
            setTableResultTitle(`Risultati`);
            setTableResultSubtitle(`UFFICI`);
            setTableResultSubtitle2("");
        }
    }

    useEffect(() => {
        handleResetSearch();
    }, [activeSearchType]);

    useEffect(() => {
        if (comuneFilter && !isLoadingFilterFromCookies) {
            setTipoUfficioFilter("");
            setTestoFilter("");
            setRegioneFilter("");
            setProvinciaFilter("");
            setDistrettoFilter("");
            setCircondarioFilter("");
            setUfficiFilter("");
        }
        clearResult();
    }, [comuneFilter]);

    useEffect(() => {
        if (provinciaFilter && !isLoadingFilterFromCookies) {
            setTipoUfficioFilter("");
            setTestoFilter("");
            setComuneFilter("");
            setDistrettoFilter("");
            setCircondarioFilter("");
            setUfficiFilter("");
        }
        clearResult();
    }, [provinciaFilter]);

    useEffect(() => {
        if (regioneFilter && !isLoadingFilterFromCookies) {
            setTipoUfficioFilter("");
            setTestoFilter("");
            setProvinciaFilter("");
            setComuneFilter("");
            setDistrettoFilter("");
            setCircondarioFilter("");
            setUfficiFilter("");
        }
        clearResult();
    }, [regioneFilter]);

    useEffect(() => {
        if (!distrettoFilter)
            getCircondariAsync(distrettoFilter);

        if (distrettoFilter && !isLoadingFilterFromCookies) {
            setTipoUfficioFilter("");
            setTestoFilter("");
            setRegioneFilter("");
            setProvinciaFilter("");
            setComuneFilter("");
            setCircondarioFilter("");
            getCircondariAsync(distrettoFilter);
            setUfficiFilter("");
        }
        clearResult();
    }, [distrettoFilter]);

    useEffect(() => {
        if (circondarioFilter && !isLoadingFilterFromCookies) {
            setTipoUfficioFilter("");
            setTestoFilter("");
            setProvinciaFilter("");
            setComuneFilter("");
            setUfficiFilter("");
        }
        clearResult();
    }, [circondarioFilter]);

    useEffect(() => {
        if (tipoUfficioFilter && !isLoadingFilterFromCookies) {
            setTestoFilter("");
            setRegioneFilter("");
            setProvinciaFilter("");
            setComuneFilter("");
            setCircondarioFilter("");
            setDistrettoFilter("");
            setUfficiFilter("");
        }
        clearResult();
    }, [tipoUfficioFilter]);

    useEffect(() => {
        if (testoFilter && !isLoadingFilterFromCookies) {
            setTipoUfficioFilter("");
            setRegioneFilter("");
            setProvinciaFilter("");
            setComuneFilter("");
            setCircondarioFilter("");
            setDistrettoFilter("");
            setUfficiFilter("");
        }
        clearResult();
    }, [testoFilter]);

    // useEffect(() => {
    //     if (isLoadingFilterFromCookies) {

    //         const cookies = new Cookies();
    //         const cookiesStored = cookies.getAll()

    //         if (cookiesStored.comuneFilter) {
    //             setComuneFilter(cookiesStored.comuneFilter);
    //         }
    //         if (cookiesStored.regioneFilter) {
    //             setRegioneFilter(cookiesStored.regioneFilter);
    //         }
    //         if (cookiesStored.provinciaFilter) {
    //             setProvinciaFilter(cookiesStored.provinciaFilter);
    //         }
    //         if (cookiesStored.distrettoFilter) {
    //             setDistrettoFilter(cookiesStored.distrettoFilter);
    //         }
    //         if (cookiesStored.circondarioFilter) {
    //             setCircondarioFilter(cookiesStored.circondarioFilter);
    //         }
    //         if (cookiesStored.tipoUfficioFilter) {
    //             setTipoUfficioFilter(cookiesStored.tipoUfficioFilter);
    //         }
    //         if (cookiesStored.testoFilter) {
    //             setTestoFilter(cookiesStored.testoFilter);
    //         }
    //     }
    // }, [isLoadingFilterFromCookies])

    const [userLocation, setUserLocation] = useState(null);
    const [userComune, setUserComune] = useState(null);

    const [queryParamsSearch, setQueryParamsSearch] = useState(false);

    const [isLoadingFilters, setIsLoadingFilters] = useState(true);
    useEffect(async () => {
        setIsLoadingFilters(true);

        const queryParams = new URLSearchParams(location.search);
        var comune = queryParams.get('comune');
        var distretto = queryParams.get('distretto');
        var circondario = queryParams.get('circondario');
        var provincia = queryParams.get('provincia');
        var regione = queryParams.get('regione');
        var tipoUfficio = queryParams.get('tipoUfficio');
        var testo = queryParams.get('testo');
        var uffici = queryParams.get('uffici');
        let isQueryParamsSearchActive = comune || regione || provincia || distretto || circondario || tipoUfficio || testo || uffici;
        setQueryParamsSearch(isQueryParamsSearchActive);

        await getTipiUfficiAsync();
        if (isQueryParamsSearchActive) {
            comune && await getComuniAsync(null, 0, 10000, true);
            regione && await getRegioniAsync();
            provincia && await getProvinceAsync();
            distretto && await getDistrettiAsync();
            circondario && await getCircondariAsync();
        } else {
            await getComuniAsync(null, 0, 10000, true);
            await getRegioniAsync();
            await getProvinceAsync();
            await getDistrettiAsync();
            await getCircondariAsync();
        }

        setIsLoadingFilters(false);
    }, []);

    const resolveLatAndLongCoordinates = async (lat, long) => {

        const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${long}`;
        const r = await fetchOk(
            url,
            {
                method: HttpMethods.GET,
            },
            true
        );
        const data = await r.json();
        var comune = data.address.village;
        if (comune == null) {
            comune = data.address.town;
        }
        if (comune == null) {
            comune = data.address.city;
        }

        setUserComune(comune);
    }

    const [isWidgetConfigurationPageOpen, setIsWidgetConfigurationPageOpen] = useState(false);
    const [isXMLPageOpen, setIsXMLPageOpen] = useState(false);
    const [isSwaggerPageOpen, setIsSwaggerPageOpen] = useState(false);
    const [isLinkCreationDialogOpen, setIsLinkCreationDialogOpen] = useState(false);

    // const handleCookieData = () => {

    //     const cookies = new Cookies();
    //     const cookiesStored = cookies.getAll()

    //     if (cookiesStored.comuneFilter || cookiesStored.regioneFilter || cookiesStored.provinciaFilter || cookiesStored.distrettoFilter || cookiesStored.circondarioFilter || cookiesStored.tipoUfficioFilter || cookiesStored.testoFilter) {
    //         setIsLoadingFilterFromCookies(true);
    //         handleWidgetSearchSubmit(cookiesStored.comuneFilter, cookiesStored.regioneFilter, cookiesStored.provinciaFilter, cookiesStored.distrettoFilter, cookiesStored.circondarioFilter, cookiesStored.tipoUfficioFilter, cookiesStored.testoFilter);
    //     }

    // }

    //region Get Options

    const [isLoadingDistretti, setIsLoadingDistretti] = useState(false);
    const getDistrettiAsync = async (pageIndex = 0, pageSize = 1000) => {
        try {
            setIsLoadingDistretti(true);
            const r = await fetchOk(ApiRoutes.Ufficio.GetDistretti({ pageIndex, pageSize }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            setState({ distretti: list.result.sort((a, b) => a.nome.localeCompare(b.nome)), distrettiOptions: list.result.map(e => { return { ufficioId: e.id, label: `${e.nome}` } }).sort((a, b) => a.label.localeCompare(b.label)) });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingDistretti(false);
        }
    }

    const [isLoadingCircondari, setIsLoadingCircondari] = useState(false);
    const getCircondariAsync = async (distrettoId = null, pageIndex = 0, pageSize = 1000) => {
        try {
            setIsLoadingCircondari(true);
            const r = await fetchOk(ApiRoutes.Ufficio.GetCircondari({ pageIndex, pageSize, distrettoId }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            setState({ circondari: list.result.sort((a, b) => a.nome.localeCompare(b.nome)), circondariOptions: list.result.map(e => { return { ufficioId: e.id, label: `${e.nome}` } }).sort((a, b) => a.label.localeCompare(b.label)) });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingCircondari(false);
        }
    }

    const [isLoadingComuni, setIsLoadingComuni] = useState(false);
    const getComuniAsync = async (term, pageIndex = 0, pageSize = 100, valid = true) => {
        try {
            setIsLoadingComuni(true);
            const r = await fetchOk(ApiRoutes.Comune.GetComuni({ term, pageIndex, pageSize, valid }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            setState({ comuni: list.result, comuniOptions: list.result.map(e => { return { comuneId: e.id, label: `${e.nome} (${e.siglaProvincia})` } }).sort((a, b) => a.label.localeCompare(b.label)) });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingComuni(false);
        }
    }

    const [isLoadingRegioni, setIsLoadingRegioni] = useState(false);
    const getRegioniAsync = async (pageIndex = 0, pageSize = 100) => {
        try {
            setIsLoadingRegioni(true);
            const r = await fetchOk(ApiRoutes.Regione.GetRegioni({ pageIndex, pageSize }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            setState({ regioni: list.result, regioniOptions: list.result.map(e => { return { regioneId: e.id, label: e.descrizione } }).sort((a, b) => a.label.localeCompare(b.label)) });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingRegioni(false);
        }
    }

    const [isLoadingProvince, setIsLoadingProvince] = useState(false);
    const getProvinceAsync = async (pageIndex = 0, pageSize = 300, regioneId = null) => {
        try {
            setIsLoadingProvince(true);
            const r = await fetchOk(ApiRoutes.Provincia.GetProvince({ pageIndex, pageSize, regioneId }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            setState({ province: list.result, provinceOptions: list.result.map(e => { return { provinciaId: e.id, label: `${e.descrizione} - (${e.sigla})` } }).sort((a, b) => a.label.localeCompare(b.label)) });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingProvince(false);
        }
    }

    //endregion

    //region Get Uffici

    const [isLoadingUfficiTipoUfficio, setIsLoadingUfficiTipoUfficio] = useState(false);
    const getUfficiTipoUfficioAsync = async (tipoUfficioId = null, pageIndex = 0, pageSize = 1000) => {
        try {
            setIsLoadingUfficiTipoUfficio(true);
            const r = await fetchOk(ApiRoutes.Ufficio.GetUfficiTipoUfficio({ pageIndex, pageSize, tipoUfficioId }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            const uffici = list.result;
            sortUffici(uffici);
            setState({ uffici: uffici, altriUffici: [] });
            await getUfficiTipoUfficioXMLAsync(tipoUfficioId, pageIndex, pageSize);
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingUfficiTipoUfficio(false);
        }
    }

    const [isLoadingUfficiLibera, setIsLoadingUfficiLibera] = useState(false);
    const getUfficiLiberaAsync = async (testo = null, pageIndex = 0, pageSize = 1000) => {
        try {
            setIsLoadingUfficiLibera(true);
            const r = await fetchOk(ApiRoutes.Ufficio.GetUfficiLibera({ pageIndex, pageSize, testo }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            const uffici = list.result;
            sortUffici(uffici);
            setState({ uffici: uffici, altriUffici: [] });
            await getUfficiLiberaXMLAsync(testo, pageIndex, pageSize);
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingUfficiLibera(false);
        }
    }

    const [isLoadingUffici, setIsLoadingUffici] = useState(false);
    const getUfficiAsync = async (ufficiIds = null, pageIndex = 0, pageSize = 1000) => {
        try {
            setIsLoadingUffici(true);
            const r = await fetchOk(ApiRoutes.Ufficio.GetUffici({ pageIndex, pageSize, ufficiIds }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            const uffici = list.result;
            sortUffici(uffici);
            setState({ uffici: uffici, altriUffici: [] });
            await getUfficiXMLAsync(ufficiIds, pageIndex, pageSize);
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingUffici(false);
        }
    }

    const [isLoadingUfficiDistretto, setIsLoadingUfficiDistretto] = useState(false);
    const getUfficiDistrettoAsync = async (distrettoId = null, circondarioId = null, pageIndex = 0, pageSize = 1000) => {
        try {
            setIsLoadingUfficiDistretto(true);
            const r = await fetchOk(ApiRoutes.Ufficio.GetUfficiDistretto({ pageIndex, pageSize, ufficioId: circondarioId ? circondarioId : distrettoId }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            const uffici = list.result;
            sortUffici(uffici);
            setState({ uffici: uffici, altriUffici: [] });
            getUfficiDistrettoXMLAsync(circondarioId, distrettoId, pageIndex, pageSize);
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingUfficiDistretto(false);
        }
    }

    const [isLoadingUfficiTerritorio, setIsLoadingUfficiTerritorio] = useState(false);
    const getUfficiTerritorioAsync = async (regioneId = null, provinciaId = null, pageIndex = 0, pageSize = 1000) => {
        try {
            setIsLoadingUfficiTerritorio(true);
            const r = await fetchOk(ApiRoutes.Ufficio.GetUfficiTerritorio({ pageIndex, pageSize, regioneId, provinciaId }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            const uffici = list.result;
            sortUffici(uffici)
            setState({ uffici: uffici, altriUffici: [] });
            getUfficiTerritorioXMLAsync(regioneId, provinciaId, pageIndex, pageSize);
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingUfficiTerritorio(false);
        }
    }

    const [isLoadingComuneUffici, setIsLoadingComuneUffici] = useState(false);
    const getComuneUfficiAsync = async (comuneId, pageIndex = 0, pageSize = 1000) => {
        try {
            setIsLoadingComuneUffici(true);
            const r = await fetchOk(ApiRoutes.Comune.GetUffici({ pageIndex, pageSize, comuneId }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            const uffici = list.result;
            sortUffici(uffici)
            setState({ uffici: uffici });
            getComuneUfficiXMLAsync(comuneId, pageIndex, pageSize);
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingComuneUffici(false);
        }
    }



    const [isLoadingComuneAltriUffici, setIsLoadingComuneAltriUffici] = useState(false);
    const getComuneAltriUfficiAsync = async (comuneId, pageIndex = 0, pageSize = 1000) => {
        try {
            setIsLoadingComuneAltriUffici(true);
            const r = await fetchOk(ApiRoutes.Comune.GetAltriUffici({ pageIndex, pageSize, comuneId }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            const altriUffici = list.result;
            sortUffici(altriUffici);
            setState({ altriUffici: altriUffici });
            getComuneAltriUfficiXMLAsync(comuneId, pageIndex, pageSize);
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingComuneAltriUffici(false);
        }
    }

    //endregion

    //region Get Tipi

    const [isLoadingTipiUffici, setIsLoadingTipiUffici] = useState(false);
    const getTipiUfficiAsync = async (pageIndex = 0, pageSize = 100) => {
        try {
            setIsLoadingTipiUffici(true);
            const r = await fetchOk(ApiRoutes.TipoUfficio.GetTipiUffici({ pageIndex, pageSize }), {
                method: HttpMethods.GET
            });
            const list = await r.json();

            const tuttiTipiUffici = list.result;
            const tuttiTipiUfficioptions = tuttiTipiUffici.map(e => { return { tipoUfficioId: e.id, label: e.nome } })
            setState({ tuttiTipiUffici: tuttiTipiUffici, tuttiTipiUfficioptions: tuttiTipiUfficioptions });

            const r2 = await fetchOk(ApiRoutes.TipoUfficio.GetTipiUffici({ pageIndex, pageSize, filtroRicercaTipoUfficio: true }), {
                method: HttpMethods.GET
            });
            const list2 = await r2.json();

            const tipiUffici = list2.result.filter(x => x.filtroRicerca);
            const tipiUfficiOptions = tipiUffici.map(e => { return { tipoUfficioId: e.id, label: e.nome } })
            setState({ tipiUffici: tipiUffici, tipiUfficiOptions: tipiUfficiOptions });

            const tipiUfficiDistrettuali = list.result.filter(x => x.filtroRicercaDistrettuale);
            const tipiUfficiDistrettualiOptions = tipiUfficiDistrettuali.map(e => { return { tipoUfficioId: e.id, label: e.nome } });
            setState({ tipiUfficiDistrettuali: tipiUfficiDistrettuali, tipiUfficiDistrettualiOptions: tipiUfficiDistrettualiOptions });

            const tipiUfficiRicerca = list2.result.filter(x => x.filtroRicercaTipoUfficio);
            const tipiUfficiRicercaOptions = tipiUfficiRicerca.map(e => { return { tipoUfficioId: e.id, label: e.nome } });
            setState({ tipiUfficiRicerca: tipiUfficiRicerca, tipiUfficiRicercaOptions: tipiUfficiRicercaOptions })
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingTipiUffici(false);
        }
    }

    //endregion

    //region Get Uffici XML

    const [isLoadingUfficiTipoUfficioXML, setIsLoadingUfficiTipoUfficioXML] = useState(false);
    const getUfficiTipoUfficioXMLAsync = async (tipoUfficioId = null, pageIndex = 0, pageSize = 1000) => {
        try {
            setIsLoadingUfficiTipoUfficioXML(true);
            const r = await fetchOk(ApiRoutes.Ufficio.GetUfficiTipoUfficioXML({ pageIndex, pageSize, tipoUfficioId }), {
                method: HttpMethods.GET
            });
            const result = await r.text();
            setState({ ufficiXML: result, altriUfficiXML: null });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingUfficiTipoUfficioXML(false);
        }
    }

    const [isLoadingUfficiLiberaXML, setIsLoadingUfficiLiberaXML] = useState(false);
    const getUfficiLiberaXMLAsync = async (testo = null, pageIndex = 0, pageSize = 1000) => {
        try {
            setIsLoadingUfficiLiberaXML(true);
            const r = await fetchOk(ApiRoutes.Ufficio.GetUfficoLiberaXML({ pageIndex, pageSize, testo }), {
                method: HttpMethods.GET
            });
            const result = await r.text();
            setState({ ufficiXML: result, altriUfficiXML: null });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingUfficiLiberaXML(false);
        }
    }

    const [isLoadingUfficiTerritorioXML, setIsLoadingUfficiTerritorioXML] = useState(false);
    const getUfficiTerritorioXMLAsync = async (regioneId = null, provinciaId = null, pageIndex = 0, pageSize = 1000) => {
        try {
            setIsLoadingUfficiTerritorioXML(true);
            const r = await fetchOk(ApiRoutes.Ufficio.GetUfficiTerritorioXML({ pageIndex, pageSize, regioneId, provinciaId }), {
                method: HttpMethods.GET
            });
            const result = await r.text();
            setState({ ufficiXML: result, altriUfficiXML: null });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingUfficiTerritorioXML(false);
        }
    }

    const [isLoadingUfficiDistrettoXML, setIsLoadingUfficiDistrettoXML] = useState(false);
    const getUfficiDistrettoXMLAsync = async (distrettoId = null, circondarioId = null, pageIndex = 0, pageSize = 1000) => {
        try {
            setIsLoadingUfficiDistrettoXML(true);
            const r = await fetchOk(ApiRoutes.Ufficio.GetUfficiDistrettoXML({ pageIndex, pageSize, ufficioId: circondarioId ? circondarioId : distrettoId }), {
                method: HttpMethods.GET
            });
            const result = await r.text();
            setState({ ufficiXML: result, altriUfficiXML: null });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingUfficiDistrettoXML(false);
        }
    }

    const [isLoadingComuneUfficiXML, setIsLoadingComuneUfficiXML] = useState(false);
    const getComuneUfficiXMLAsync = async (comuneId, pageIndex = 0, pageSize = 100) => {
        try {
            setIsLoadingComuneUfficiXML(true);
            const r = await fetchOk(ApiRoutes.Comune.GetUfficiXML({ pageIndex, pageSize, comuneId }), {
                method: HttpMethods.GET
            });
            const result = await r.text();
            setState({ ufficiXML: result });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingComuneUfficiXML(false);
        }
    }

    const [isLoadingComuneAltriUfficiXML, setIsLoadingComuneAltriUfficiXML] = useState(false);
    const getComuneAltriUfficiXMLAsync = async (comuneId, pageIndex = 0, pageSize = 100) => {
        try {
            setIsLoadingComuneAltriUfficiXML(true);
            const r = await fetchOk(ApiRoutes.Comune.GetAltriUfficiXML({ pageIndex, pageSize, comuneId }), {
                method: HttpMethods.GET
            });
            const result = await r.text();
            setState({ altriUfficiXML: result });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingComuneAltriUfficiXML(false);
        }
    }

    const [isLoadingUfficiXML, setIsLoadingUfficiXML] = useState(false);
    const getUfficiXMLAsync = async (ufficiIds = null, pageIndex = 0, pageSize = 1000) => {
        try {
            setIsLoadingUfficiXML(true);
            const r = await fetchOk(ApiRoutes.Ufficio.GetUfficiXML({ pageIndex, pageSize, ufficiIds }), {
                method: HttpMethods.GET
            });
            const result = await r.text();
            setState({ ufficiXML: result });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingUfficiXML(false);
        }
    }

    //endregion

    return (
        <Provider value={{
            isWidgetConfigurationPageOpen,
            setIsWidgetConfigurationPageOpen,
            isXMLPageOpen,
            setIsXMLPageOpen,
            isSwaggerPageOpen,
            setIsSwaggerPageOpen,
            isLinkCreationDialogOpen,
            setIsLinkCreationDialogOpen,

            state,
            setState,

            isLoadingComuni,
            getComuniAsync,

            isLoadingTipiUffici,
            getTipiUfficiAsync,

            isLoadingRegioni,
            getRegioniAsync,

            isLoadingProvince,
            getProvinceAsync,

            isLoadingComuneUffici,
            getComuneUfficiAsync,

            isLoadingComuneUfficiXML,
            getComuneUfficiXMLAsync,

            isLoadingComuneAltriUffici,
            getComuneAltriUfficiAsync,

            isLoadingComuneAltriUfficiXML,
            getComuneAltriUfficiXMLAsync,

            isLoadingUfficiTipoUfficio,
            getUfficiTipoUfficioAsync,

            isLoadingUfficiTipoUfficioXML,
            getUfficiTipoUfficioXMLAsync,

            isLoadingUfficiLibera,
            getUfficiLiberaAsync,

            isLoadingUfficiLiberaXML,
            getUfficiLiberaXMLAsync,

            isLoadingUfficiDistretto,
            getUfficiDistrettoAsync,

            isLoadingUfficiDistrettoXML,
            getUfficiDistrettoXMLAsync,

            isLoadingUfficiTerritorio,
            getUfficiTerritorioAsync,

            isLoadingUfficiTerritorioXML,
            getUfficiTerritorioXMLAsync,

            isLoadingDistretti,
            getDistrettiAsync,

            isLoadingCircondari,
            getCircondariAsync,

            isLoadingUffici,
            getUfficiAsync,

            isLoadingUfficiXML,
            getUfficiXMLAsync,

            resolveLatAndLongCoordinates,
            userLocation,
            setUserLocation,
            userComune,

            tipoUfficioFilter,
            setTipoUfficioFilter,

            testoFilter,
            setTestoFilter,

            comuneFilter,
            setComuneFilter,

            regioneFilter,
            setRegioneFilter,

            provinciaFilter,
            setProvinciaFilter,

            distrettoFilter,
            setDistrettoFilter,

            circondarioFilter,
            setCircondarioFilter,

            ufficiFilter,
            setUfficiFilter,

            handleSearchSubmit,
            handleWidgetSearchSubmit,
            handleResetSearch,

            isLoadingFilterFromCookies,
            setIsLoadingFilterFromCookies,
            // handleCookieData,
            tableResultTitle,
            tableResultSubtitle,
            tableResultSubtitle2,
            advancedSearchActive,
            setAdvancedSearchActive,

            activeSearchType,
            setActiveSearchType,


            isLoadingFilters,
            queryParamsSearch,
        }}>
            {props.children}
        </Provider>
    );
}